import(/* webpackMode: "eager" */ "/app/src/app/[festival-slug]/[locale]/(auth)/forgot-password/page.tsx");
